import { Logos as YdleLogos } from "@yodlee/common-components/dist/assets";
import { Row, Typography } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { Logos } from "../../assets";
import { BROWSER_DOWNLOAD_URLS } from "../../configurations/url";

function getLatestBrowser(browserName: "firefox" | "chrome" | "iexplorer" | "edge" | "safari" | "opera") {
    if (BROWSER_DOWNLOAD_URLS[browserName]) window.open(BROWSER_DOWNLOAD_URLS[browserName]);
}

export default function BrowserCompatibility({ allowProceed, onProceedClick }: any) {
    return <Row>
        <img alt="Yodlee-label" src={YdleLogos.EnvestnetYodleeLabel} style={{ position: "absolute", top: "32px", left: "32px", maxHeight: "48px", maxWidth: "150px" }} />
        <Row style={{ paddingTop: "100px" }}>
            <div className="padding-sm-horizontal" style={{ maxWidth: "920px", margin: "auto" }}>
                <Title className='color-blue'>Upgrade browser for the best My Yodlee experience</Title>
                <Typography style={{ fontSize: "16px" }}>
                    It looks like you may be using a web browser version that we don’t support. Make sure you’re using the most recent version of your browser, or try using one of these supported browsers to get the best My Yodlee experience.
            </Typography>
            </div>
        </Row>
        <Row className="padding-top-xxl">
            <div style={{ maxWidth: "750px", margin: "auto" }}>
                <ul style={{ listStyleType: "none" }}>
                    <li className="brwsr-icn-item" onClick={() => getLatestBrowser("chrome")}>
                        <img src={Logos.Chrome} alt="chrome" />
                        <span className="color-blue-5 brwsr-icn-txt" >Chrome</span>
                    </li>
                    <li className="brwsr-icn-item" onClick={() => getLatestBrowser("firefox")}>
                        <img src={Logos.FireFox} alt="firefox" />
                        <span className="color-blue-5 brwsr-icn-txt">Firefox</span>
                    </li>
                    <li className="brwsr-icn-item" style={{ maxWidth: "120px" }} onClick={() => getLatestBrowser("iexplorer")}>
                        <img src={Logos.IExplorer} alt="iexplorer" />
                        <span className="color-blue-5 brwsr-icn-txt">Internet Explorer</span>
                    </li>
                    <li className="brwsr-icn-item" onClick={() => getLatestBrowser("edge")}>
                        <img src={Logos.Edge} alt="edge" />
                        <span className="color-blue-5 brwsr-icn-txt" >Edge</span>
                    </li>
                    <li className="brwsr-icn-item" onClick={() => getLatestBrowser("safari")}>
                        <img src={Logos.Safari} alt="safari" />
                        <span className="color-blue-5 brwsr-icn-txt" >Safari</span>
                    </li>
                    <li className="brwsr-icn-item" onClick={() => getLatestBrowser("opera")}>
                        <img src={Logos.Opera} alt="safari" />
                        <span className="color-blue-5 brwsr-icn-txt">Opera</span>
                    </li>
                </ul>
            </div>
        </Row>
        {
            allowProceed && <Row className="padding-top-lg">
                <div style={{ maxWidth: "680px", margin: "auto" }}>
                    <hr style={{ borderTop: "none", borderColor: "rgba(0,0,0,0.15)" }} />
                    <div className="color-gray-5 padding-top-lg" style={{ textAlign: "center" }}>
                        <span className="brwsr-icn-txt" onClick={onProceedClick}>Proceed anyways</span>
                    </div>
                </div>
            </Row>
        }
    </Row>
}